import { ReactElement, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from 'antd';

import { ConfirmDeleteModal } from '@ohpen/enso-ui';
import { DeleteExportTemplateError, ExportTemplateResponse, deleteExportTemplate } from '@pmp/api';
import { createDeleteErrorException } from '@pmp/utils';
import { DeleteModalProps } from '@pmp/types';

const { Text } = Typography;

export const ExportTemplatesDeleteModal = ({
  open,
  record,
  onClose,
  refreshTable,
}: DeleteModalProps<ExportTemplateResponse>): ReactElement => {
  const { t } = useTranslation();
  const { id, name } = record || {};

  const onConfirmDelete = useCallback(() => {
    return id
      ? deleteExportTemplate({ path: { templateId: id } })
          .then(() => {
            onClose();
            refreshTable();
            return { description: t('enso.notifications.xDeletedSuccessfully', { x: t('global.labels.exportTemplate') }) };
          })
          .catch((error: DeleteExportTemplateError) => {
            onClose();
            return Promise.reject(createDeleteErrorException(error));
          })
      : Promise.reject(createDeleteErrorException({ title: t('enso.errors.invalidRecord') }));
  }, [id, onClose, refreshTable, t]);

  return (
    <ConfirmDeleteModal
      title={t('enso.labels.deleteX', { x: t('global.labels.exportTemplate') })}
      open={open}
      onConfirm={onConfirmDelete}
      onCancel={onClose}
    >
      <Text>
        <Trans i18nKey="global.labels.confirmDeleteX" values={{ x: name }} components={{ italic: <i /> }} />
      </Text>
    </ConfirmDeleteModal>
  );
};
